import { render, staticRenderFns } from "./AccumulationSellingGroup.vue?vue&type=template&id=23fb8880&scoped=true"
import script from "./AccumulationSellingGroup.vue?vue&type=script&lang=js"
export * from "./AccumulationSellingGroup.vue?vue&type=script&lang=js"
import style0 from "./AccumulationSellingGroup.vue?vue&type=style&index=0&id=23fb8880&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fb8880",
  null
  
)

export default component.exports